import React from "react";


import { viewModes, formatTime } from "../../common/common";
import { IcChevrDown, IcChevrLeft, IcFilter, IcResetFilter} from "../../common/svg";
import { HOME } from "../../../constant/routes";
import { withRouter } from "react-router";



class SearchFilterBox extends React.Component {
	constructor(props) {
		super(props);
    }

	setListView = () => {
		this.props.setListView()
	}

	setMapView = () => {
		this.props.setMapView()
	}

	toggleFilter = () => {
		this.props.toggleFilter()
	}

	toggleSearching = () => {
		this.props.toggleSearching()
	}

	resetFilter = () => {
		this.props.resetFilter()
	}


	render() {
		const { address, isSD, formatWdAddress, addressPlaceHolder, addressBanner,  viewMode, filter, customFilterConfig, visible, prevUrl } = this.props;
		const { startDate, endDate, startTime, endTime } = filter 
		const hasFilter = this.props.hasFilter(filter, customFilterConfig)
		
		return (
			<div className={`finding-filter-mobile-section ${viewMode === viewModes.LIST ? 'fixed' : ''} ${visible ? "" : "scroll-top"}`}> 
				<div className="m-container"> 
					<a onClick={() => { 
							if (prevUrl !== "") {
								window.location.href = prevUrl;
							} else {
								props.history.back()
							}
						}} className="wrap-svg back">
						<IcChevrLeft />
					</a>
					<div className="finding-mobile" onClick={this.toggleSearching}> 
						<div className="address" > 
							{isSD ?
								<p>{address !== "" ? address : (addressPlaceHolder.includes("Nhập địa chỉ") ? addressBanner : "Vị trí trên bản đồ.")}</p>
								: 
								<p>{address[0] !== "" ? formatWdAddress : (addressPlaceHolder.includes("Nhập địa chỉ") ? addressBanner : "Vị trí trên bản đồ.")}</p>
							}
					
							<div className="wrap-svg">
								<IcChevrDown />
							</div>
						</div>
					{/* <span className="date-time">{startDate ? startDate.format("DD/MM/YYYY") : 'Chọn ngày bắt đầu'}<span className="dot">•</span>{endDate ? endDate.format("DD/MM/YYYY - HH:mm") : "Chọn ngày kết thúc"}</span> */}
					<span className="date-time">
						{startTime >= 0 ? formatTime(startTime) : 'Chọn giờ'},{" "}
						{startDate
							? startDate.format("DD/MM/YYYY")
							: carFinding.filter.startDate
							? carFinding.filter.startDate.format("DD/MM/YYYY")
							: "Chọn ngày"}{" "}
						<span className="dot">•</span>
						{endTime >= 0 ? formatTime(endTime) : 'Chọn giờ'},{" "}
						{endDate
							? endDate.format("DD/MM/YYYY")
							: "Chọn ngày"}
					</span>
				</div>
			<div className="filter-mobile"> 
					{/* <div className={`filter-mobile__item reset-item ${hasFilter ? 'active' : ''}`} onClick={this.resetFilter}>
						<div className="wrap-svg">
							<IcResetFilter />
						</div>
					</div> */}
					<div className="filter-mobile__item" onClick={this.toggleFilter}> 
						<div className="wrap-svg">
							<IcFilter />
						</div>
						{/* <p>Bộ lọc</p> */}
					</div>
				</div>
			</div>
		</div> 
		)
	}
}

export default withRouter(SearchFilterBox)
